module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-16.07a8a094.png";